import { render, staticRenderFns } from "./PlatformsLogo.vue?vue&type=template&id=0ebbd8d9&"
import script from "./PlatformsLogo.vue?vue&type=script&lang=js&"
export * from "./PlatformsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports